import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';
import upload from 'assets/dashboard/upload.png';

import AssetUploadDashboard from './assetUpload';

export const UTILITIES_RESOURCES = {
	assetUpload: 'assetUpload'
};

export const URL = {
	[UTILITIES_RESOURCES.assetUpload]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.utilities}/${UTILITIES_RESOURCES.assetUpload}`
};

export const LABEL = {
	[UTILITIES_RESOURCES.assetUpload]: 'Upload Assets'
};

export const COMPONENT = {
	[UTILITIES_RESOURCES.assetUpload]: AssetUploadDashboard
};

export const GET_ACTION = {
	[UTILITIES_RESOURCES.assetUpload]: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.utilities].getAllAssets
};

export const IMAGE_SOURCE = {
	[UTILITIES_RESOURCES.assetUpload]: upload
};
